import { useCallback } from 'react';
import { v4 } from 'uuid';
import { useEnabledFeatures } from '../../../common/hooks/enabled-features';
import { useIntegratedActionBroadcaster } from '../../../action-broadcaster/use-integrated-action-broadcaster';
import { useApplicationType } from '../../../common/hooks/use-application-type';

export function useSendAssociatedPhoneNumberIdToMap(): (phoneNumberId: number | undefined) => void {
    const { disableLegacyMapAndSearches, mapWindowEnabled } = useEnabledFeatures();
    const { trigger } = useIntegratedActionBroadcaster();
    const { isWeb } = useApplicationType();

    return useCallback(
        function broadcastAssociatedPhoneNumberIdToMap(phoneNumberId: number | undefined) {
            const shouldBroadcast = disableLegacyMapAndSearches || mapWindowEnabled;
            const shouldSkipClearingOnWeb = isWeb && phoneNumberId === undefined;

            if (!shouldBroadcast || shouldSkipClearingOnWeb) {
                return;
            }

            const action = {
                id: v4(),
                type: 'SET_ASSOCIATED_PHONE_NUMBER_ID',
                targetWindowType: 'MAP_V2',
                payload: {
                    phoneNumberId,
                },
            } as const;

            trigger([action]);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [disableLegacyMapAndSearches, mapWindowEnabled]
    );
}
